// 肿瘤结果
import React, { useState, useEffect } from "react";
import { Button, Progress } from "antd-mobile";
import styled from "styled-components";

export default function Result(props: any) {
  const { value, tumourType } = props;

  // 复发概率
  const ProcessOne = (props: any) => {
    if (props.value === 0) {
      return (
        <div className="progress">
          <span>第一年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>15%</span>
            <span>(10%-19%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={15}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>15%</span>
          </div>
        </div>
      );
    } else if (props.value > 0 && props.value < 5) {
      return (
        <div className="progress">
          <span>第一年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>24%</span>
            <span>(21%-26%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={24}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 5 }}
            />
            <span style={{ color: "#38B7D2" }}>24%</span>
          </div>
        </div>
      );
    } else if (props.value > 4 && props.value < 10) {
      return (
        <div className="progress">
          <span>第一年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>38%</span>
            <span>(35%-41%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={38}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>38%</span>
          </div>
        </div>
      );
    } else {
      return (
        <div className="progress">
          <span>第一年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>61%</span>
            <span>(55%-67%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={61}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>61%</span>
          </div>
        </div>
      );
    }
  };
  const ProcessFive = (props: any) => {
    if (props.value === 0) {
      return (
        <div className="progress">
          <span>第五年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>31%</span>
            <span>(24%-37%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={31}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>31%</span>
          </div>
        </div>
      );
    } else if (props.value > 0 && props.value < 5) {
      return (
        <div className="progress">
          <span>第五年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>46%</span>
            <span>(42%-49%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={46}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>46%</span>
          </div>
        </div>
      );
    } else if (props.value > 4 && props.value < 10) {
      return (
        <div className="progress">
          <span>第五年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>62%</span>
            <span>(58%-65%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={62}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>62%</span>
          </div>
        </div>
      );
    } else {
      return (
        <div className="progress">
          <span>第五年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>78%</span>
            <span>(73%-84%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={78}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>78%</span>
          </div>
        </div>
      );
    }
  };

  // 进展概率
  const ProcessRateOne = (props: any) => {
    if (props.value === 0) {
      return (
        <div className="progress">
          <span>第一年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>0.2%</span>
            <span>(0%-0.7%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={0.2}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>0.2%</span>
          </div>
        </div>
      );
    } else if (props.value > 1 && props.value < 7) {
      return (
        <div className="progress">
          <span>第一年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>1%</span>
            <span>(0.4%-1.6%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={1}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>1%</span>
          </div>
        </div>
      );
    } else if (props.value > 6 && props.value < 14) {
      return (
        <div className="progress">
          <span>第一年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>5%</span>
            <span>(4%-7%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={5}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>5%</span>
          </div>
        </div>
      );
    } else {
      return (
        <div className="progress">
          <span>第一年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>17%</span>
            <span>(10%-34%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={17}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>17%</span>
          </div>
        </div>
      );
    }
  };
  const ProcessRateFive = (props: any) => {
    if (props.value === 0) {
      return (
        <div className="progress">
          <span>第五年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>0.8%</span>
            <span>(0%-1.7%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={0.8}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>0.8%</span>
          </div>
        </div>
      );
    } else if (props.value > 1 && props.value < 7) {
      return (
        <div className="progress">
          <span>第五年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>6%</span>
            <span>(5%-8%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={6}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>6%</span>
          </div>
        </div>
      );
    } else if (props.value > 6 && props.value < 14) {
      return (
        <div className="progress">
          <span>第五年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>17%</span>
            <span>(14%-20%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={17}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>17%</span>
          </div>
        </div>
      );
    } else {
      return (
        <div className="progress">
          <span>第五年</span>
          <div>
            <span style={{ marginRight: 10, fontWeight: "bold" }}>45%</span>
            <span>(35%-55%)</span>
          </div>
          <div
            style={{
              width: "36%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Progress
              percent={45}
              position="normal"
              style={{
                width: "100%",
                height: 10,
                background: "#CCE8EF",
                borderRadius: 5,
                marginRight: 5,
              }}
              barStyle={{ background: "#38B7D2", borderRadius: 3 }}
            />
            <span style={{ color: "#38B7D2" }}>45%</span>
          </div>
        </div>
      );
    }
  };

  return (
    <div>
      <ResultBox>
        <div className="result">
          <div className="resultPart">
            <div
              style={{
                color: "rgba(0,96,113,0.7)",
                fontSize: 14,
                lineHeight: "20px",
                textAlign: "center",
                paddingTop: 16,
              }}
            >
              根据2020EAU指南复发和进展计算器逻辑,评定此次风险等级为:
            </div>
            <div
              style={{
                color:
                  tumourType === "低危肿瘤"
                    ? "#14D58C"
                    : tumourType === "中危肿瘤!"
                    ? "#FF9514"
                    : tumourType === "高危肿瘤!!"
                    ? "#FF3C14"
                    : "red",
                textAlign: "center",
                fontSize: 20,
                fontWeight: "bold",
                width: 213,
                height: 40,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "0 auto",
                marginTop: 18,
                borderRadius: 4,
                border: `1px solid ${
                  tumourType === "低危肿瘤"
                    ? "#14D58C"
                    : tumourType === "中危肿瘤!"
                    ? "#FF9514"
                    : tumourType === "高危肿瘤!!"
                    ? "#FF3C14"
                    : "red"
                }`,
              }}
            >
              {tumourType}
            </div>
            <div
              style={{
                color: "rgba(0,96,113,0.7)",
                fontSize: 14,
                lineHeight: "20px",
                textAlign: "center",
                paddingTop: 16,
              }}
            >
              经尿道膀胱肿瘤电切手术后，不进行卡介苗或化疗药灌注的情况下肿瘤复发和进展的概率
            </div>
          </div>
          <div className="part">
            {/* 复发概率 */}
            <div className="partItem">
              <h5 className="partName">膀胱癌（NMIBC）复发概率及置信区间</h5>
              {/* 进度区间 */}
              <ProcessOne value={value[0]} />
              <ProcessFive value={value[0]} />
            </div>
            {/* 进展概率 */}
            <div className="partItem" style={{ marginTop: 12 }}>
              <h5 className="partName">膀胱癌（NMIBC）进展概率及置信区间</h5>
              {/* 进度区间 */}
              <ProcessRateOne value={value[1]} />
              <ProcessRateFive value={value[1]} />
            </div>
          </div>
        </div>
      </ResultBox>
    </div>
  );
}

const ResultBox = styled.div`
  height: 100%;
  .result {
    height: 100%;
    padding: 20px 10px 40px;
  }
  .resultPart {
    width: 98%;
    // height: 134px;
    border-radius: 4px;
    background-color: white;
    margin: 0 auto;
    position: relative;
    padding: 8px;
    box-sizing: border-box;
  }
  .part {
    margin-top: 15px;
  }
  .partName {
    color: #333333;
    font-weight: bold;
    border-bottom: 1px solid #f4f4f4;
    font-size: 14px;
    padding-bottom: 14px;
    margin: 0;
  }
  .progress {
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5px;
    margin-bottom: 10px;
  }
  .progress .am-progress-bar {
    height: 10px !important;
  }
  .progress .am-progress-outer {
    width: 55% !important;
  }
  .am-progress-bar {
    border: none;
  }
  .partItem {
    width: 98%;
    height: 138px;
    background-color: white;
    border-radius: 4px;
    margin: 0 auto;
    padding: 14px;
    box-sizing: border-box;
  }
`;
